// extracted by mini-css-extract-plugin
export default {"voice_chat_user_list":"UserList_voice_chat_user_list__dlwG1","placeholder":"UserList_placeholder__ANfaf"};